export default {
      id: "flex-flexDirection-column-reverse-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-flexDirection-column-reverse-usage",
      toString: function () {
        return this.url;
      }
    }